import { useMagicKeys, whenever } from '@vueuse/core'
import router from '@/router'

export function useDebugKeyChangePage() {
  const keys = useMagicKeys()

  whenever(keys.shift_space, () => {
    console.log('Shift+Space have been pressed')
  })

  whenever(keys.pageup, () => {
    router.push({ path: '/' })
  })

  whenever(keys.pagedown, () => {
    router.push({ path: '/about' })
  })
}
